import { Checkbox, MenuItem, Stack, Typography } from "@mui/material"
import { type TreeNode, getNodeState } from "../treeSelectMenu.utils"
import { MenuItemContainer } from "./MenuItemContainer"

export interface TreeLeafItemProps<T extends string = string> {
  node: TreeNode<T>
  value: T[]
  indent?: number
  onSelect: (node: TreeNode<T>) => void
}

export const TreeLeafItem = <T extends string = string>({
  node,
  value,
  indent = 0,
  onSelect,
}: TreeLeafItemProps<T>) => {
  const state = getNodeState(node, value)
  return (
    <MenuItemContainer>
      <MenuItem
        onClick={() => onSelect(node)}
        aria-checked={state === "checked"}
        sx={{ pl: 2 + indent * 3 }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Checkbox
            data-testid={`tree-checkbox-${node.code}`}
            checked={state === "checked"}
            onClick={(e) => e.stopPropagation()}
            onChange={() => onSelect(node)}
          />
          <Typography>{node.label}</Typography>
        </Stack>
      </MenuItem>
    </MenuItemContainer>
  )
}
